<!--
  通用头部组件
 -->

<template>
  <div class="common-head">
    <div class="head-left">
      <h1 class="title"><a href="/">{{corpName}}</a></h1>
      <span class="slogan">欢迎您使用销帮帮CRM</span>
      <span v-if="isDingTalk" @click="openBrowser" class="open-browser">在浏览器中打开</span>
    </div>
    <div class="user">
      <a v-if="userAvatar" href="/user/myInfo.html" class="avatar">
        <img :src="userAvatar" :alt="userName">
      </a>
      <!-- <a v-else href="/user/myInfo.html" class="avatar dd-ava" :style="avatarBgc">{{dingAvatar.name}}</a> -->

      <a @click.prevent="optionShow=!optionShow" v-clickoutside="hide" :class="{active: optionShow}" class="name">{{userName}}<i class="el-icon-caret-bottom"></i></a>
      <ul class="option" v-show="optionShow">
        <li><a class="item" href="/user/myInfo.html">个人信息</a></li>
        <li><a class="item" href="/user/logout.html">退出登录</a></li>
      </ul>
    </div>
    <div class="remind">
      <span @click="clickMessageBox">提醒（{{getRemindCount < 0 ? 0 : getRemindCount}}）</span>
    </div>

    <div class="cti-note" v-if="getCTIStatus">
      <div class="note-btn head-item" v-if="moduleType === 305" @click="$router.push('/callCenter/calllog?result=0')">
        <i class="web-icon-callin"></i>
        <span class="note-text">未接来电</span>
        <i class="tag" v-if="getMissCallCount">{{getMissCallCount}}</i>
      </div>
      <div class="note-btn head-item" v-if="moduleType === 302" @click="noteListShow = !noteListShow">
        <i class="web-icon-callin"></i>
        <span class="note-text">未接来电</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <ul class="note-list" v-if="noteListShow">
        <li class="item" v-for="item in missedCallList">
          <span class="call-num">{{item.anotherPhoneNum}}</span>
          <span class="call-name">
            <template v-if="item.refType === 404">
              {{item.refName}}
            </template>
            <a v-else href="javascript:;" @click="openDetail(item)">
              {{item.refName}}
            </a>
          </span>
          <span class="call-btn" @click="makeCall(item.anotherPhoneNum)">
            <i class="web-icon-callout"></i>
          </span>
        </li>
        <li class="empty" v-if="!missedCallList.length">没有未接来电</li>
        <!-- <li class="more">查看全部通话记录</li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { LS } from 'assets/js/storage'
import * as api from 'src/api'
import { mapGetters, mapActions } from 'vuex'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
let timer = null
// require('assets/js/avatar.js')

export default {
  data () {
    return {
      optionShow: false,
      userName: '',
      userAvatar: '',
      corpName: '',
      dingAvatar: {},
      // 是否显示消息列表
      showMessageList: false,
      missedCallList: [],
      noteListShow: false,
      refInfos: {},
      // 获取呼叫中心的moduleType
      moduleType: Number(LS.get('VUE-CTI-moduleType')),
      isDingTalk: utils.isDingTalk()
    }
  },
  created () {
    const url = '/user/getNowLoginData.html'
    api.post(url, {}, (data) => {
      this.userName = data.result.userName
      this.userAvatar = data.result.userAvatar
      this.corpName = data.result.corpName
      // this.dingAvatar = window.ddAvatar.getAvatar(this.userName, this.userName)
    })

    this.getRemind()
  },

  computed: {
    ...mapGetters([
      'getRemindCount', // 获取提醒数目
      'getCTIStatus', // VUEX中的一个状态，电话状态
      'getMissCallCount' // 未接来电数量
    ]),
    // 默认头像背景色
    avatarBgc () {
      return `background-color: ${this.dingAvatar.color};`
    }
  },
  methods: {
    ...mapActions([
      'updateRemindCount', // 更新提醒数
      'updateMissCallCount' // 更新未接来电数
    ]),
    hide () {
      this.optionShow = false
    },
    // 获取提醒信息
    getRemind () {
      let url = '/pushlink/unreadCount.do'
      api.post(url, {}, (data) => {
        this.updateRemindCount(data.result.count)
      })
      clearTimeout(timer)

      // 每隔1小时，请求一次提醒信息
      timer = setTimeout(() => {
        this.getRemind()
      }, 3600 * 1000)
    },
    // 弹出提醒消息
    clickMessageBox () {
      this.$emit('getMessageList')
      // this.showMessageList = true
    },

    // 获取未接来电
    getMissedCall () {
      const url = '/callcenter/missedCall/list.do'
      let params = {
        moduleType: this.moduleType,
        page: 1,
        pageSize: 10
      }
      api.post(url, params, (data) => {
        this.updateMissCallCount(data.result.totalElements) // 拿到数目
        this.missedCallList = data.result.callLogList // 拿到对应条目
      })
    },

    makeCall (phone) {
      window.CALL_CENTER.callme(phone)
    },

    // 打开来电用户的详情页
    openDetail (item) {
      // TODO: 2017-11-20
      // 这里需要在全局状态下打开详情或新建，目前无法做到
      // 未来可能要把新建和详情挂在到全局，随时可调用，目测代码改动较大
    },

    // 在浏览器中打开
    openBrowser () {
      const url = window.location.pathname + window.location.hash
      const goUrl = utils.openBlankUrl(url)
      window.open(goUrl)
    }
  },
  components: {
  },
  watch: {
    getCTIStatus (value) {
      if (value === true) {
        this.getMissedCall()
      }
    }
  },
  directives: { Clickoutside }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .common-head {
    position: relative;
    flex: 0 0 40px;
    height: 40px;
    width: 100%;
    background-color: @bg-light;
    color: #fff;
    .detail-bg {
      opacity: 0;
    }
    z-index: 100;
    a {
      color: #fff;
    }
    .head-left {
      padding: 11px 0 0 50px;
      height: 18px;
      line-height: 18px;
      float: left;
      .title {
        display: inline-block;
        font-size: 16px;
        margin-right: 30px;
      }
      .slogan {
        display: inline-block;
        padding-left: 30px;
        border-left: 1px solid #fff;
      }
      .open-browser {
        cursor: pointer;
        display: inline-block;
        margin-left: 30px;
        padding: 4px 12px;
        border-radius: 10px;
        line-height: 1;
        color: #eee;
        background-color: @bg-orange;
        font-size: 12px;
        &:hover {
          color: #ffffff;
        }
      }
    }
    .user {
      float: right;
      .avatar {
        display: inline-block;
        width: 30px;
        height: 30px;
        margin: 5px 15px 0 0;
        &.dd-ava {
          border-radius: 15px;
          line-height: 30px;
          text-align: center;
          font-size: 12px;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .name {
        display: inline-block;
        vertical-align: top;
        height: 40px;
        line-height: 40px;
        padding: 0 30px;
        &.active, &:hover {
          background-color: @bg-dark;
        }
        .el-icon-caret-bottom {
          display: inline-block;
          vertical-align: middle;
          line-height: 40px;
          font-size: 12px;
          margin-left: 6px;
        }
      }
      .option {
        position: absolute;
        right: 0;
        top: 100%;
        width: 140px;
        background-color: @bg-light;
        border-top: 1px solid @bg-dark;
        z-index: 100;
        .item {
          display: block;
          line-height: 32px;
          font-size: 12px;
          text-align: center;
          border-bottom: 1px solid @bg-dark;
          &:hover {
            background-color: @bg-dark;
          }
        }
      }
    }
    .head-item {
      float: right;
      padding: 13px 40px 0 0;
      cursor: pointer;
      padding: 0 10px 0 20px;
      margin-right: 20px;
      margin-top: 5px;
      border-radius: 14px;
      background-color: #2E3E57;
      line-height: 28px;
      height: 28px;
      font-size: 13px;
      .tag {
        background-color: #f00;
        padding: 2px 5px;
        line-height: 1;
        position: absolute;
        font-style: normal;
        border-radius: 10px;
        right: 12px;
        top: 1px;
      }
    }
    .remind {
      float: right;
      height: 38px;
      line-height: 38px;
      padding-right: 12px;
      cursor: pointer;
    }
    .cti-note {
      float: right;
      position: relative;
      .note-btn {
        cursor: pointer;
        padding-right: 15px;
        .el-icon-caret-bottom {
          font-size: 12px;
        }
      }
      .note-list {
        position: absolute;
        left: 0;
        top: 40px;
        background-color: #fff;
        width: 260px;
        box-shadow: 0 2px 3px 3px rgba(55, 77, 99, 0.3);
        .item {
          border-bottom: 1px solid #dedede;
          height: 49px;
          padding-right: 50px;
          padding-left: 10px;
          position: relative;
          .call-num {
            display: block;
            font-size: 13px;
            color: #FF6161;
            line-height: 28px;
          }
          .call-name {
            line-height: 1;
            font-size: 13px;
            color: #999;
            a {
              // color: @primary;
              color: #999;
              cursor: default;
            }
          }
          .call-btn {
            position: absolute;
            width: 49px;
            height: 49px;
            right: 0;
            top: 0;
            text-align: center;
            line-height: 49px;
            background-color: #F3F8FF;
            color: @primary;
            font-size: 15px;
            cursor: pointer;
            transition: all 0.3s;
            .web-icon-callout {
              transition: all 0.3s;
            }
            &:hover {
              background-color: #e3e8f5;
              .web-icon-callout {
                transform: scale(1.5);
              }
            }
          }
        }
        .empty {
          padding: 25px;
          text-align: center;
          line-height: 1;
          color: #999;
        }
        .more {
          font-size: 13px;
          padding: 11px;
          text-align: center;
          background-color: #6A82A4;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    &:after {
      clear: both;
      content: "";
      height: 0;
    }
    .back-to {
      float: right;
      display: inline-block;
      height: 22px;
      line-height: 21px;
      padding: 0 15px;
      border-radius: 12px;
      margin: 9px 50px 0 0;
      background-color: #1C3148;
      color: #fff;
      font-size: 12px;
      opacity: 0.85;
      transition: all 0.3s;
      &:hover {
        box-shadow: 0 0 2px 2px #122134 inset;
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// common-head.vue?0659eb40